import { useQuery, UseQueryOptions } from 'react-query'
import QUERIES from 'api/queries'
import WealthicaAPI from './services'
import { IGetWealthicaTransactionsResponse } from './models'

export const useNewWealthicaTransactions = (
	lastTransactionId?: string,
	options?: Omit<
		UseQueryOptions<
			IGetWealthicaTransactionsResponse,
			unknown,
			IGetWealthicaTransactionsResponse,
			(string | undefined)[]
		>,
		'queryKey' | 'queryFn'
	>
) =>
	useQuery(
		[QUERIES.wealthicaNewTransactions, lastTransactionId],
		() => WealthicaAPI.getNewCryptoTransactions(lastTransactionId),
		options
	)
